export enum ERoleSource {
  MANUAL = 'manual',
  KEYCLOAK = 'keycloak',
}
